import { LocalAdapter, SessionAdapter, Storage } from '@mirai/data-sources';
import { ServiceUser } from '@mirai/services';

import { logout } from './logout';
import { toUrlParams } from '../components/helpers/toUrlParams';
import { ENDPOINT } from '../components/Session/Session.constants';
import { AUTH_TYPE, GUESTMAKER_SIGNED_IN, GUESTMAKER_SILENT_LOGIN, SENATOR_CLUB_TOKEN } from '../Core.constants';

const shouldSilentLogin = (skip) => {
  try {
    const silentLogin = new SessionAdapter();
    const signedIn = new LocalAdapter().get(GUESTMAKER_SIGNED_IN);
    if (!signedIn) silentLogin.set(GUESTMAKER_SILENT_LOGIN);
    if (!signedIn || skip || silentLogin.get(GUESTMAKER_SILENT_LOGIN) === signedIn) return false;
    silentLogin.set(GUESTMAKER_SILENT_LOGIN, signedIn);
    return true;
  } catch {
    return false;
  }
};

export const fetchExternalSession = async ({ config = {}, cookies = {}, id, language, session, urlParams = {} }) => {
  const { accomodation: { club: { authentication: { type } = {} } = {} } = {} } = config;
  if (type === AUTH_TYPE.MIRAI) return session;

  let token;
  if (type === AUTH_TYPE.PESTANA) token = cookies.pestana;
  else if (type === AUTH_TYPE.SENATOR) {
    const tokenData = new Storage({ adapter: LocalAdapter }).get(SENATOR_CLUB_TOKEN);
    if (tokenData) token = window.btoa(encodeURIComponent(JSON.stringify(tokenData)));
  } else if (type === AUTH_TYPE.GUESTMAKER) {
    token = urlParams.hlCode;
    const url = new URL(window.location.href);
    const hlError = url.searchParams.has('hlError');
    if (url.searchParams.has('hlCode') || hlError) {
      url.searchParams.delete('hlCode');
      url.searchParams.delete('hlError');
      window.history.replaceState(window.history.state, '', url.href);
    }
    if (shouldSilentLogin(!!token || !!session || hlError)) {
      window.location.href = `${process.env.SERVICE_USER}/${ENDPOINT.EXTERNAL_LOGIN}${toUrlParams({
        idtokenprovider: id,
        domain: url.href,
        lang: language,
        prompt: 'none',
      })}`;
      return new Promise(() => {});
    }
    if (!token) return session;
  }

  let value;
  if (session && !token) logout();
  else if (!session && token)
    value = await ServiceUser.externalLogin(token, type, type === AUTH_TYPE.GUESTMAKER ? id : undefined).catch();
  else if (session && token) value = session;

  return value;
};
